var MpPageLegaladviserSend;

(function() {
    if (!document.querySelector('#vue-body-legaladviser-send')) {
        return;
    }

    Vue.component('file-upload', VueUploadComponent);

    MpPageLegaladviserSend = new Vue({
        el: '#vue-body-legaladviser-send',
        mixins: [],
        data: {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,

            // Those global_ comes from Notes Controller PHP
            TXT_ACTION_DELETE: global_cancelButtonText,
            TXT_FAIL_UPLOAD: global_failUploadText,
            TXT_OK_UPLOAD: global_okUploadText,
            TXT_DRAG: global_drag,

            FORM_URL: '/legaladviser/addconsult',
            REMOVE_URL: '/server/uploads/delete.php',

            detail: '',
            link: '',
            fileName: '',
            fileUploaded: '',
            files: [],
            fsecure: '',

            upload: null,

            errors: [],
            successMessage: '',
            validated: false,

            overlay: null,
            isSending: false,
            isLegalShown: false,
            isInitialized: false,
        },
        components: {
            FileUpload: VueUploadComponent
        },
        computed: {
            detailCheck: function() {
                return !this.validated || !FormValidator.isEmpty(this.detail);
            },
            linkCheck: function() {
                return !this.validated || FormValidator.isEmpty(this.link) || FormValidator.isValidURL(this.link);
            },
            dataForm: function() {
                return Serializer.serialize({
                    'detail': this.detail,
                    'link0': this.link,
                    'file': this.file,
                    'privacity': true,
                    'fsecure': this.fsecure
                });
            }
        },
        methods: {

            sizeKb: function(bytes) {
                return (bytes/1024).toFixed(2);
            },

            cleanErrors: function() {
                this.errors = [];
            },

            addError: function(errorMsg) {
                if (this.errors.length > 0) {
                    return;
                }

                this.errors.push(errorMsg);
            },

            validateForm: function() {
                /// error_data, data_ko
                /// are globally injected from PHP controller
                var isValid = true;

                this.cleanErrors();
                this.validated = true;

                if (!this.detailCheck) {
                    isValid = false;
                    this.addError(error_data);
                }

                if (!this.linkCheck) {
                    isValid = false;
                    this.addError(data_ko);
                }

                return isValid;
            },

            onRemoveFile: function(response) {
                if (response.status !== 200) {
                    console.error('Error: ' + response.statusText);
                }
            },

            removeFile: function(file) {
                axios
                    .post(this.REMOVE_URL, Serializer.serialize({'name': file.name}))
                    .then(this.onRemoveFile)
                    .catch(function(error) {
                        console.error(error);
                    });
            },

            inputFile: function (newFile, oldFile) {
                // https://lian-yue.github.io/vue-upload-component/#/en/documents#options-events-input-file

                if (newFile && oldFile) {

                    // new upload
                    if (!newFile.active && oldFile.active) {

                        if (!newFile.xhr || newFile.xhr.status !== 200) {
                            console.error('Error peticion XHR');
                            return;
                        }

                        var fileInfo;
                        try {
                            fileInfo = JSON.parse(newFile.response).files[0];

                            if (fileInfo.error) {
                                newFile.success = false;
                                newFile.error = fileInfo.error;
                                return;
                            }

                            this.file = fileInfo.safe_name;
                        } catch (error) {
                            newFile.success = false;
                            newFile.error = this.TXT_FAIL_UPLOAD;
                        }
                    }
                }

                // Remove file
                if (!newFile && oldFile && oldFile.success) {
                    this.removeFile(oldFile);
                }

                // Autoupload file
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (!this.upload.active) {
                        this.upload.active = true;
                    }
                }
            },

            resetForm: function() {
                this.detail = '';
                this.link = '';
                this.privacity = true;

                this.fileUploaded = '';
                this.fileName = '';
                this.upload.clear();

                this.validated = false;
                this.cleanErrors();
            },

            onSend: function(result) {
                this.isSending = false;

                if (result.data.result === 'OK') {
                    this.successMessage = result.data.message;
                    this.resetForm();
                } else {
                    this.addError(result.data.message);
                }
            },

            sendConsultation: function() {
                this.successMessage = '';

                if (!this.isSending && this.validateForm()) {
                    this.isSending = true;

                    axios
                        .post(this.FORM_URL, this.dataForm)
                        .then(this.onSend)
                        .catch(function(error) {
                            console.log(error);
                        });
                }
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.overlay = this.$refs.overlay;
                this.$refs.fsecure.style.display = 'none';
            },
        },
        filters: {},

        mounted: function() {
            this.upload = this.$refs.upload;

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },
    });

})();
